export default "__VITE_ASSET__By3DS0nB__"